

import { isLoaded, useFirestoreConnect, } from "react-redux-firebase";
import {  useSelector } from "react-redux";
import React, { useState, useEffect } from 'react';
import {
    getFirestore,
  } from "redux-firestore";
import { DeleteTables, SetTableBiz } from '../Redux/actions';
import AddTableModal from '../components/AddTableModal';
import TableDetailsModal from '../components/TableDetailsModel';
import {  useHistory } from "react-router-dom";
import WindowQrComponent from '../components/assetComponent/windowsQr';
import { SERVICE_QR_ID, TABLE_QR_ID, WINDOW_QR_ID, downloadQr } from '../utils/qr_util';
import ServiceDeskQrComponent from '../components/assetComponent/servicedeskQr';
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import {VStack,Center,Text, Modal, FormControl,} from 'native-base'
import {CircularProgress,Box, Typography,Button, IconButton, Alert} from '@mui/material'
import { DeleteForever, Edit, DoneAll,Visibility } from '@mui/icons-material';
import EditReservationModal from "../components/EditReservationModal";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { EditReservation,AddReservations,ChangeResevationStatus } from "../Redux/actions";
import { deleteStatusFor } from "../services/reservationsApi";
import { formatAuDate, toDateValue } from "../utils/reservationDisplay";
const columns = [
      {
        field: 'sn' , 
        headerName: 'S.N',
        headerAlign:'center',
        align:'center',
        width:30, 
        filterable: false,
        renderCell:(params) => params.api.getRowIndexRelativeToVisibleRows(params.row.id) + 1
    },
    { field: "username", headerName: "Customer", width: 120 },
    {field:"numberOfPeople",headerName:"No.People",width:100,align:"center"},
    {field:"reservationStatus",headerName:"Status",width:85,
  
    renderCell:(params)=>{
      let status = params.row['reservationStatus']
      return (
        <Typography bgcolor={status=='pending'?'blue':status=='fulfilled'?'green':'orange'} color={'white'} p={0.5}>
         {status}
        </Typography>
      )
    }
  },
    { field: "accessibilityNotes", headerName: "Dietary & Accessibility", width: 200 },
   
    {
      field:"reservationDate",
      headerName: "Date",
      type: "date",
      width: 130,
      align:'center',
      headerAlign: 'center',
      valueGetter:(params)=>toDateValue(params.row['reservationDate']),
      valueFormatter:(params)=>formatAuDate(params.value)
    },
    {
      field:"timeFrom",
      headerName:"Time From",
      type:"time",
      headerAlign: 'center',
      

      width:90,
      align:'center'
    },
    {
      field:"timeTo",
      headerName:"Time To",
      type:"time",
      headerAlign: 'center',
      width:80,
      align:'center'
    },
    {
      field:'date',
      headerName:'Created',
      headerAlign: 'center',
      type:"date",
      width: 130,
      // `date` may be a Firestore Timestamp (staff API) or a string (older docs)
      valueGetter:(params)=>toDateValue(params.row['date']),
      valueFormatter:(params)=>formatAuDate(params.value)
    },
    {
      field:"occasion",
      headerName:'Occasion',
      type:"string",
      width: 90
    },
    {
      field:"tableMode",
      headerName:"Table Mode",
      align:'center',
      type:"string",
      width:90
    },
    { field: "area", headerName: "Area", width: 70 },
    {
      field:"userEmail",
      headerName:"User Email",
      type:"string",
      width:130,
      
    },
    {
      field:"userPhone",
      headerName:"Phone",
      type:"string",
      width:130
    },
    
  ];

  const getCols=(actionListener,business)=>{

    let cols = [...columns]
    
    
    

    return [
      ...columns,
      {
        field: "action",
        headerName: "Action",
        sortable: false,
        width:210,
        renderCell: (params) => {
          const onClick = (e) => {
            e.stopPropagation(); // don't select this row after clicking
            const api  = params.api;
            const thisRow= params.row;
            
                    
          };
    
        return (
        <Box>
          {
            params.row.reservationStatus !== "fulfilled"?
            <IconButton onClick={actionListener?()=>actionListener.status(params.row,
              params.row.reservationStatus == 'pending'?
            'confirmed':
            params.row.reservationStatus == 'confirmed'?
            'fulfilled':params.row.reservationStatus
            ):undefined}>
            <DoneAll/>
          </IconButton>:null
          }
         
          <IconButton onClick={actionListener?()=>actionListener.edit(params.row):undefined} >
            <Edit/>
          </IconButton>
          {/* Phone bookings are removed; customer bookings are canceled (deposit refunded) */}
          <IconButton
            aria-label={deleteStatusFor(params.row) === 'removed' ? 'Remove booking' : 'Cancel booking'}
            onClick={actionListener?()=>actionListener.status(params.row,deleteStatusFor(params.row)):undefined}
          >
            <DeleteForever />
          </IconButton>
          <IconButton>
            <Visibility/>
          </IconButton>
          </Box>
           )
        }
      }
    ]

  }
  
  const rows = [
    { id: 1, lastName: "Snow", firstName: "Jon", age: 35 },
    { id: 2, lastName: "Lannister", firstName: "Cersei", age: 42 },
    { id: 3, lastName: "Lannister", firstName: "Jaime", age: 45 },
    { id: 4, lastName: "Stark", firstName: "Arya", age: 16 },
    { id: 5, lastName: "Targaryen", firstName: "Daenerys", age: null },
    { id: 6, lastName: "Melisandre", firstName: null, age: 150 },
    { id: 7, lastName: "Clifford", firstName: "Ferrara", age: 44 },
    { id: 8, lastName: "Frances", firstName: "Rossini", age: 36 },
    { id: 9, lastName: "Roxie", firstName: "Harvey", age: 65 }
  ];

  

  


export const reservationListErrorMessage = (err) => {
  const code = err?.code || ""
  if (code === "permission-denied") return "Couldn't load reservations: this account isn't allowed to read this venue's bookings yet. New bookings are still saved."
  if (code === "failed-precondition") return "Couldn't load reservations: the database index this list needs hasn't been created yet. New bookings are still saved."
  return `Couldn't load reservations${code ? ` (${code})` : ""}. Please refresh.`
}

// Listener rows plus rows saved/edited locally (keyed by reservationId).
// Local copies of final statuses are dropped, like the list query does.
const LISTED_STATUSES = ['pending','confirmed','expired','fulfilled']
export const mergeReservationRows = (live, local) => {
  const byId = {}
  ;(live || []).forEach((r) => { byId[r.reservationId || r.id] = r })
  Object.entries(local || {}).forEach(([rid, row]) => {
    const base = byId[rid]
    // This page's own saved changes win (the listener copy may still be stale)
    byId[rid] = base ? { ...base, ...row } : { ...row, id: row.id || rid }
  })
  return Object.values(byId).filter((r) => !r.reservationStatus || LISTED_STATUSES.includes(r.reservationStatus))
}

const ReservationPage =(props)=>{
    useEffect(() => { document.title = "Reservations | Piatto"; }, []);
    const id = props.match.params.id;
    const history = useHistory();
    const reservationsKey = `venueReservations_${id}`;

    const [currentReservation,setCurrentReservation] = useState()
    const [newResev,setNewRev] = useState(false)

  
    useFirestoreConnect([
        {
          collection: "Business",
          doc: id,
          storeAs: "reservationBusiness",
        }
    ]);

    useFirestoreConnect([
        {
          collection:"Reservations",
          where: [["bizId", "==", `${id}`],["reservationStatus", "in", ['pending','confirmed','expired','fulfilled']]],
          orderBy: [["date", "desc"]],
          storeAs: reservationsKey,
        }
    ])

    const SingleBusiness = useSelector(
        ({ firestore: { data } }) => data.reservationBusiness
    );
    const venueLoaded = isLoaded(SingleBusiness) && !!SingleBusiness;

    const liveReservations = useSelector(
      ({ firestore: { ordered } }) => ordered[reservationsKey]
    )
    // Listener failures (e.g. permission-denied, or failed-precondition when
    // the composite index is missing) used to look like "No rows".
    const listError = useSelector(
      ({ firestore }) => firestore?.errors?.byQuery?.[reservationsKey]
    )
    // Bookings saved/edited in this session, shown at once even before (or
    // without) the Firestore listener delivering them.
    const [localRows, setLocalRows] = useState({})
    const reservations = mergeReservationRows(liveReservations, localRows)
      
    

   

    // Writes go through the staff reservation API (see services/reservationsApi).
    // `id` is the Business doc ID from the route.
    const handleFBEdit=async (re)=>{
      // Send only what changed, compared with the stored reservation
      const original = reservations?.find(r=>r.reservationId===re.reservationId) || currentReservation
      const res = await EditReservation(original, re, id)
      if (res.ok && res.changes) {
        setLocalRows((rows)=>({ ...rows, [original.reservationId]: { ...original, ...res.changes } }))
      }
      return res
    }

    const handleUpdateRow=async (row,status)=>{
      let reservation = reservations.find(r=>r.reservationId===row.reservationId)
      if(reservation){
        const res = await ChangeResevationStatus(reservation,status,id)
        if (res && res.ok) {
          setLocalRows((rows)=>({ ...rows, [reservation.reservationId]: { ...reservation, reservationStatus: status } }))
        }
      }
    }

    const handleFBadd = async (rev)=>{
      const res = await AddReservations(rev,id)
      const saved = res.ok && res.data && (res.data.reservation || (res.data.reservationId && { ...rev, reservationId: res.data.reservationId }))
      if (saved) {
        const rid = saved.reservationId || res.data.reservationId
        setLocalRows((rows)=>({ ...rows, [rid]: { ...saved, reservationId: rid } }))
      }
      return res
    }

    const handleClickedEditRow =(row)=>{

      let reservation = reservations.find(r=>r.reservationId===row.reservationId)
      if(reservation){
        setCurrentReservation(reservation)
      }

    }

    {

        return(

            <VStack role="main" >


            <Center>
            <Text color={"white"} position={"absolute"} zIndex={99999} top={-50}>
                {SingleBusiness?.bizName || ""}
              </Text>
            </Center>
            
              <Button mb={1} onClick={() => history.goBack()} w={"100%"}>
            Back to Order Page 
          </Button>

           <Typography variant="h4" margin={2}>
            Reservations
           </Typography>
           <Button
            size="medium"
            sx={{maxWidth:200,margin:1}}
            color="success" 
            variant="contained"
            disabled={!venueLoaded}
            onClick={()=>{
              setNewRev(true)
            }}
            > 
             Add Reservation
           </Button>
            {listError ? (
              <Alert severity="error" sx={{ m: 1 }} role="alert">
                {reservationListErrorMessage(listError)}
              </Alert>
            ) : null}
            <Box margin={1} sx={{ height: 500, width: '100%' }}>

            <DataGrid
               
               rows={reservations??[]}
               columns={getCols({
                status:handleUpdateRow,
                edit:handleClickedEditRow
              
              })}
               initialState={{
               pagination: {
                   paginationModel: { page: 0, pageSize: 5 }
               }
               }}
             
               pageSizeOptions={[5, 10]}

               sx={{
                
                '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
                  borderRight: `1px solid #f0f0f0`
               },
               '& .MuiDataGrid-root, .MuiDataGrid-cell ':{
                whiteSpace: 'normal !important',
                wordWrap: 'break-word !important'
              }
              }}
           />
            </Box>
           
            {/* Mount the modals only once the venue has loaded (they read biz) */}
            {venueLoaded && (
            <>
            <EditReservationModal
             biz={SingleBusiness} 
             onClose={()=>{
              setCurrentReservation(undefined)
             }}
             open={!!currentReservation}
             reservation={currentReservation}
             onSave ={
              async (reservation)=>{
                const res = await handleFBEdit(reservation)
                if (res.ok) setCurrentReservation(undefined)
                return res
              }
             }
             />

             <EditReservationModal
             biz={SingleBusiness} 
              open={newResev}
              onClose={()=>{
                setNewRev(false)
              }}
              onSave={
                async (reservation)=>{
                  const res = await handleFBadd(reservation)
                  if (res.ok) setNewRev(false)
                  return res
                }
              }
             />
            </>
            )}
             
            </VStack>
             
            
        )

    }

    


}

export default ReservationPage;